import { render, staticRenderFns } from "./RecordList.vue?vue&type=template&id=9be3130e&scoped=true&"
import script from "./RecordList.vue?vue&type=script&lang=tsx&"
export * from "./RecordList.vue?vue&type=script&lang=tsx&"
import style0 from "./RecordList.vue?vue&type=style&index=0&id=9be3130e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be3130e",
  null
  
)

export default component.exports